<section class="scal">
  <div class="scal__toolbar">
    <div class="scal__nav">
      <button type="button" class="scal__nav-btn" (click)="prev()"
              [attr.aria-label]="'CALENDAR.NAV.PREV' | translate">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button type="button" class="scal__nav-btn" (click)="next()"
              [attr.aria-label]="'CALENDAR.NAV.NEXT' | translate">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
      <button type="button" class="scal__today" (click)="today()">
        {{ 'CALENDAR.NAV.TODAY' | translate }}
      </button>
    </div>

    <h2 class="scal__period">{{ periodLabel() }}</h2>

    <div class="scal__seg" role="tablist">
      <button type="button" role="tab" class="scal__seg-btn"
              [class.is-active]="activeView() === 'dayGridMonth'"
              (click)="switchView('dayGridMonth')">
        {{ 'CALENDAR.NAV.MONTH' | translate }}
      </button>
      <button type="button" role="tab" class="scal__seg-btn"
              [class.is-active]="activeView() === 'timeGridWeek'"
              (click)="switchView('timeGridWeek')">
        {{ 'CALENDAR.NAV.WEEK' | translate }}
      </button>
      <button type="button" role="tab" class="scal__seg-btn"
              [class.is-active]="activeView() === 'timeGridDay'"
              (click)="switchView('timeGridDay')">
        {{ 'CALENDAR.NAV.DAY' | translate }}
      </button>
    </div>
  </div>

  @if (errored) {
    <!-- Erreur de chargement : jamais de séances de substitution. -->
    <app-error-state titleKey="CALENDAR.ERROR_TITLE"
                     messageKey="CALENDAR.ERROR_DESC"
                     (retry)="retry.emit()"></app-error-state>
  }

  <div class="scal__grid" [class.is-loading]="loading" [class.is-hidden]="errored">
    <full-calendar [options]="calendarOptions"></full-calendar>
    @if (loading) {
      <div class="scal__veil"><span class="scal__spinner"></span></div>
    }
  </div>
</section>
